export const featureFlags = {
  requiredProof: {
    startYear: 2024,
  },
};
